/**
 * 适配JS中px转rem工具 - 带响应式缓存
 * @param {number | string} value JS中的值，如 18 或 '60px'
 * @returns {number | string} 转换后的值。如果是数字输入，返回数字；如果是字符串输入，返回带rem的字符串。
 */

let cachedScale = 1;
const designWidth = 1920;
const baseFontSize = 19.2;

// 计算当前缩放比例
const calculateScale = () => {
  const clientWidth = document.documentElement.clientWidth || document.body.clientWidth || designWidth;
  cachedScale = Math.min(clientWidth / designWidth, 2); // 限制最大缩放倍数
  return cachedScale;
};

// 初始化
calculateScale();

// 监听resize更新缓存（防抖）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    calculateScale();
  }, 100);
});

export const adaptSize = (value) => {
  if (typeof value === 'number') {
    // 对于数字，如 fontSize: 18，返回一个根据缩放比例计算后的数字
    return value * cachedScale;
  } else if (typeof value === 'string' && value.endsWith('px')) {
    // 对于字符串，如 '60px'，提取数字部分进行计算，并返回rem字符串
    const pxNum = parseFloat(value);
    const remValue = (pxNum / baseFontSize);
    return `${remValue}rem`;
  }
  // 如果不是数字也不是px字符串，原样返回（如百分比'20%'）
  return value;
};

// 获取当前scale（用于需要实时计算的场景）
export const getCurrentScale = () => cachedScale;

// 监听resize的辅助函数（可选）
export const onResize = (callback) => {
  const handler = () => callback(cachedScale);
  window.addEventListener('resize', handler);
  return () => window.removeEventListener('resize', handler);
};